import $ from 'jquery';
import { Inputs } from './modules/inputs';
jQuery(document).on('gform_post_render', function (event, form_id, current_page) {
    const inputs = document.querySelectorAll('.gform_wrapper div.gfield input');
    if (inputs.length > 0) {
        Array.from(inputs, input => {
            new Inputs(input);
        });
    }
    // code to trigger on form or form page render
});
// Smooth Scrolling
// Select all links with hashes
$('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function (event) {
    // On-page links
    if (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
        &&
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            location.hostname == this.hostname) {
        // Figure out element to scroll to
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        let target = $(this.hash);
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        // Does a scroll target exist?
        if (target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();
            $('html, body').animate({
                scrollTop: target.offset().top - 80
            }, 1000, function () {
                // Callback after animation
                // Must change focus!
                const $target = $(target);
                $target.focus();
                if ($target.is(':focus')) { // Checking if the target was focused
                    return false;
                }
                else {
                    $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                    $target.focus(); // Set focus again
                }
            });
        }
    }
});
// Smooth scroll on page ready - anchor links for other pages
if (window.location.hash) {
    let target = $(window.location.hash);
    target = target.length ? target : $('[name=' + window.location.hash.slice(1) + ']');
    if (target.length) {
        if ('replaceState' in history) {
            history.replaceState('', document.title, window.location.pathname + window.location.search);
        }
        $('html, body')
            .animate({
            scrollTop: target.offset().top - 80
        }, 1000, function () {
            // Callback after animation
            // Must change focus!
            const $target = $(target);
            $target.focus();
            if ($target.is(':focus')) { // Checking if the target was focused
                return false;
            }
            else {
                $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                $target.focus(); // Set focus again
            }
        });
    }
}
